// hooks/useScopedResetCreateBudget.ts
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import storage from 'redux-persist/lib/storage';
import { resetState } from '../features/createBudget/createBudgetSlice';

const SCOPE_PREFIXES = ['/create-budget']; // các route giữ state
const TEMP_DETOURS = [
  '/oauth/google',
  '/auth/google',
  '/integrations/google',
  '/connect/google',
  '/oauth/callback',
  '/auth/callback/google',

  '/oauth/facebook',
  '/auth/facebook',
  '/integrations/facebook',
  '/connect/facebook',
  '/auth/callback/facebook',
  '/facebook/callback',

  '/oauth/tiktok',
  '/auth/tiktok',
  '/integrations/tiktok',
  '/connect/tiktok',
  '/auth/callback/tiktok',
  '/tiktok/callback',

  '/oauth/linkedin',
  '/auth/linkedin',
  '/integrations/linkedin',
  '/connect/linkedin',
  '/auth/callback/linkedin',
  '/linkedin/callback',
];

const isIn = (path, prefixes) =>
  prefixes.some(p => path.startsWith(p));

export default function useScopedResetCreateBudget() {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const wasInScope = useRef(isIn(pathname, SCOPE_PREFIXES));

  useEffect(() => {
    const inScope = isIn(pathname, SCOPE_PREFIXES);
    const inDetour = isIn(pathname, TEMP_DETOURS);

    if (wasInScope.current && !inScope && !inDetour) {
      dispatch(resetState());
    }

    wasInScope.current = inScope || inDetour;
  }, [pathname, dispatch]);
}
